// This module handles calls to third-party analytics libraries. For
// internal analytics, use the AnalyticsReporter module
// (go/kaggle-analytics-service).
import { registerPageview } from "./ThirdPartyServices/GoogleAnalytics";
export var googleAnalyticsRegisterPageview = function(track) {
    registerPageview(track);
};
